import React, { useState } from "react";
import SwitchIcon from "src/assets/images/switch.svg";

interface QuantChartPanelProps {
    json_response: any;
}

const QuantChartPanel = ({ json_response }: QuantChartPanelProps) => {
    const [open, setOpen] = useState<boolean>(true);

    const {
        chart_configs = [],
        warnings = [],
        branding_applied = false
    } = json_response || {};

    return (
        <div
            className={`h-screen rounded-lg w-full overflow-auto pn_scroller transition-all duration-300 ease-in-out ${open
                ? "flex-[0_0_100%] sm:flex-[0_0_75%] lg:flex-[0_0_460px] max-w-full lg:max-w-[460px] p-2 border border-gray-300"
                : "flex-[0_0_100%] sm:flex-[0_0_215px] max-w-full sm:max-w-[215px]"
                }`}
        >
            <div className="flex flex-col h-full bg-opacity-50">

                {/* ───────────────── HEADER ───────────────── */}
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold">Chart Validation</h2>

                    <button
                        onClick={() => setOpen(!open)}
                        className="cursor-pointer rounded border border-[#DFE3E8] p-1 hover:bg-gray-100"
                    >
                        <img src={SwitchIcon} alt="Toggle" className="w-3 h-3 object-contain" />
                    </button>
                </div>

                {/* ───────────────── BRANDING APPLIED ───────────────── */}
                <div className="mb-4">
                    <span
                        className={`inline-block px-3 py-1 rounded-md text-sm border font-medium ${branding_applied
                            ? "text-green-700 bg-green-100 border-green-300"
                            : "text-gray-700 bg-gray-100 border-gray-300"
                            }`}
                    >
                        Branding Applied: {branding_applied ? "Yes" : "No"}
                    </span>
                </div>

                {/* ───────────────── CHART CONFIGS ───────────────── */}
                <div className="mb-6">
                    <h3 className="font-medium text-sm mb-2">Chart Configurations</h3>

                    {chart_configs.length === 0 ? (
                        <p className="text-sm text-gray-500">No chart configurations found.</p>
                    ) : (
                        <div className="overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg">
                                <thead>
                                    <tr className="bg-gray-100 text-left">
                                        <th className="p-2 border-b">Question ID</th>
                                        <th className="p-2 border-b">Recommended Type</th>
                                        <th className="p-2 border-b">Orientation</th>
                                        <th className="p-2 border-b">Show Values</th>
                                        <th className="p-2 border-b">Segments Visible</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {chart_configs.map((cfg: any, index: number) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-2 py-2 border-none">{cfg.question_id}</td>

                                            <td className="px-2 py-2 border-none">{cfg.recommended_type}</td>

                                            <td className="px-2 py-2 border-none">
                                                {cfg.is_vertical ? "Vertical" : "Horizontal"}
                                            </td>

                                            <td className="px-2 py-2 border-none">
                                                {cfg.show_values ? "Yes" : "No"}
                                            </td>

                                            <td className="px-2 py-2 border-none">
                                                {cfg.segments_visible ? "Yes" : "No"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    )}
                </div>

                {/* ───────────────── WARNINGS ───────────────── */}
                <div>
                    <h3 className="font-medium text-sm mb-2">Warnings</h3>

                    {warnings.length === 0 ? (
                        <p className="text-sm text-gray-500">No warnings detected.</p>
                    ) : (
                        warnings.map((warn: string, i: number) => (
                            <div
                                key={i}
                                className="p-2 mb-2 border border-yellow-300 bg-yellow-50 rounded-md text-sm"
                            >
                                ⚠ {warn}
                            </div>
                        ))
                    )}
                </div>

            </div>
        </div>
    );
};

export default QuantChartPanel;